export const COUNTERPARTY_CONNECTED_TYPE = {
  PAYEE: 'payee',
  PLAID: 'plaid'
};
